(function () {
    'use strict';

    angular
        .module('tswApp')
        .config(tswAppRoute);

    tswAppRoute.$inject = ['$stateProvider'];

    /* @ngInject */
    function tswAppRoute ($stateProvider) {
        $stateProvider
            .state('root.tswApp', {
                abstract: true,
                url: '/tsw-app',
                resolve: {
                    /* Inserir as regras de Acl aqui! */
                }
            })
            .state ('root.tswApp.plansAcquired', {
                url: '/report/plans-acquired',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/tsw-app/reports/plans-acquired/reportFilter.html',
                        controller: 'PlansAcquiredController',
                        controllerAs: 'plansAcquired'
                    }
                }
            })
            .state ('root.tswApp.institutions', {
                url: '/report/institutions',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/tsw-app/reports/institutions/reportFilter.html',
                        controller: 'InstitutionsAppController',
                        controllerAs: 'institutionsApp'
                    }
                }
            });
    }
})();